import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import "../styles/app.scss"

const TemplateWrapper = ({ children }) => {
  return (
    <div>
      <Helmet
        title="Illinois License Suspensions"
        meta={[
          {name: 'robots', content: 'noindex'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1.0'}
        ]}
        link={[
          {rel: "icon", href: "https://propublica.org/favicon.ico", type: "image/x-icon"}
        ]}
      />
      <div className="embed-wrapper">
        {children()}
      </div>
    </div>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js